// pages/AboutJesseGarlick.tsx
import "./styles/AboutAuthor.css";

const authorStructuredData = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: "Jesse Garlick",
  url: "https://yourenergyguru.com/about",
  image: "https://yourenergyguru.com/images/professionaljesse.jpg",
  jobTitle: "Founder",
  description:
    "Founder of Energy Guru, Mortgage Pathway, and Coverage Path. Writes and reviews every article by hand from primary sources.",
  worksFor: { "@type": "Organization", name: "Your Energy Guru" },
  knowsAbout: [
    "Residential solar",
    "Net metering",
    "Solar incentives and tax credits",
    "Solar payback and financing",
  ],
};

export default function AboutJesseGarlick() {
  return (
    <div className="author-page-container">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(authorStructuredData) }}
      />
      <div className="author-hero">
        <img
          src="/images/professionaljesse.jpg"
          alt="Jesse Garlick"
          className="author-page-image"
        />
        <h1>Jesse Garlick</h1>
        <p className="author-tagline">Founder of Energy Guru</p>
      </div>

      <section className="author-section">
        <h2>Hi, I'm Jesse 👋</h2>
        <p>
          I founded Energy Guru to help homeowners and businesses make smarter decisions
          about solar energy. My goal is to break down the complexities of solar, batteries,
          incentives, and savings into plain, honest advice that works.
        </p>
        <p>
          I've spent years working in the field, learning the ins and outs of the energy
          space — and I built Energy Guru to become the most trusted resource for anyone
          exploring solar in the U.S.
        </p>
      </section>

      <section className="author-section">
        <h2>What Makes My Content Different</h2>
        <ul>
          <li>✅ Written with accuracy, reviewed by me personally</li>
          <li>✅ Based on state-specific incentives and real savings data</li>
          <li>✅ Focused on helping you avoid sales pressure & scams</li>
        </ul>
      </section>

    

      <section className="author-section">
        <h2>Want to Go Solar?</h2>
        <p>
          Use our <a href="/calculator">Solar Savings Calculator</a> to estimate your savings — or <a href="/quote">get a free quote</a> based on your home and state.
        </p>
      </section>
    </div>
  );
}
